module.exports = __webpack_public_path__ + "static/media/two.d4362ebb.jpg";